import { render, staticRenderFns } from "./BizInvoiceinfoForm1.vue?vue&type=template&id=b96c76e2&"
import script from "./BizInvoiceinfoForm1.vue?vue&type=script&lang=js&"
export * from "./BizInvoiceinfoForm1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports